export const RECENT_SEARCHES_KEY = 'recentSearches';

export function normalizeSearchQuery(q) {
  return String(q || '').trim().replace(/\s+/g, ' ').slice(0, 80);
}

export function loadRecentSearches() {
  try {
    const raw = localStorage.getItem(RECENT_SEARCHES_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(arr)) return [];
    return arr.filter((s) => typeof s === 'string' && s.trim()).slice(0, 8);
  } catch {
    return [];
  }
}

export function saveRecentSearch(query) {
  const q = normalizeSearchQuery(query);
  if (!q) return;
  const existing = loadRecentSearches();
  const next = [q, ...existing.filter((x) => x.toLowerCase() !== q.toLowerCase())].slice(0, 8);
  try {
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(next));
  } catch {
    // ignore storage errors
  }
}

export function clearRecentSearches() {
  try {
    localStorage.removeItem(RECENT_SEARCHES_KEY);
  } catch {
    // ignore
  }
}

